
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff","stroke":"#6b7786"}},[_c('circle',{attrs:{"cx":"7","cy":"7","r":"7","stroke":"none"}}),_c('circle',{attrs:{"cx":"7","cy":"7","r":"6.5","fill":"none"}})]),_c('path',{attrs:{"d":"M5.361 13.502S.942 6.29 5.138.954M8.329 13.502s4.419-7.472.223-13","fill":"none","stroke":"#6b7786"}}),_c('line',{attrs:{"y2":"13","transform":"translate(6.717 .502)","fill":"none","stroke":"#6b7786"}}),_c('path',{attrs:{"d":"M.717 6.502A24.187 24.187 0 007.19 7.541a24.846 24.846 0 006.527-1.039","fill":"none","stroke":"#6b7786"}})])
          )
        }
      }
    